module.exports = __webpack_public_path__ + "img/listPic1.ea8de746.jpg";